import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import PayeeBankingInfo from '@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/PayeeBankingInfo'
import { observer } from 'mobx-react'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import dayjs from 'dayjs'

const RightsholderMaintenanceBankingTab = () => {
    const { popupStore } = useContext(StoresContext)

    const [isBankingLocked, setBankingLocked] = useState(true)

    const checkBankingLocked = () => {
        const currentDay = dayjs().tz('America/Chicago').date()
        if (currentDay >= 3 && currentDay <= 14) {
            setBankingLocked(true)
            popupStore.setAlertData(
                'Updating banking and tax information is temporarily unavailable from the 3rd - 14th each month.',
                false,
                false
            )
        } else {
            setBankingLocked(false)
        }
    }

    useEffect(() => {
        analyticsSendPage('rightsholder_banking')
        checkBankingLocked()
    }, [])

    return (
        <>
            <div className="rightsholder-maintenance-banking-tab">{!isBankingLocked && <PayeeBankingInfo />}</div>
        </>
    )
}

export default observer(RightsholderMaintenanceBankingTab)
